import type { RestoreSummary } from './archive';

function count(n: number, one: string, many: string): string {
  return `${String(n)} ${n === 1 ? one : many}`;
}

/** One line for the result of a restore or a sync merge. */
export function summariseMerge(summary: RestoreSummary): string {
  const added: string[] = [];
  if (summary.tracksAdded > 0) {
    added.push(count(summary.tracksAdded, 'flight', 'flights'));
  }
  if (summary.trackFilesAdded > 0) {
    added.push(count(summary.trackFilesAdded, 'track file', 'track files'));
  }
  if (summary.aircraftAdded > 0) {
    added.push(`${String(summary.aircraftAdded)} aircraft`);
  }
  if (summary.logbookEntriesAdded > 0) {
    added.push(count(summary.logbookEntriesAdded, 'logbook entry', 'logbook entries'));
  }
  if (summary.logbookChecksAdded > 0) {
    added.push(count(summary.logbookChecksAdded, 'check', 'checks'));
  }
  if (summary.settingsAdded > 0) {
    added.push('settings');
  }

  const sentences: string[] = [];
  if (added.length > 0) {
    sentences.push(`Added ${added.join(', ')}.`);
  }
  if (summary.recordsUpdated > 0) {
    sentences.push(`${count(summary.recordsUpdated, 'record', 'records')} updated.`);
  }
  if (summary.recordsDeleted > 0) {
    sentences.push(`${count(summary.recordsDeleted, 'record', 'records')} deleted.`);
  }
  return sentences.length > 0 ? sentences.join(' ') : 'No changes.';
}
